import { WFormsAPI } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaFormsV1Service = bindHTTP(WFormsAPI);
export const serviceName = 'forms-v1' as const;
